import { render } from "./TestController.vue?vue&type=template&id=5d5d5a0e&ts=true&lang=pug"
import script from "./TestController.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestController.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__